(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-mf-header]').forEach(function (header) {
      var burger = header.querySelector('[data-mf-burger]');
      var drawer = header.querySelector('[data-mf-drawer]');
      if (burger && drawer) {
        burger.addEventListener('click', function () {
          var open = drawer.hasAttribute('hidden');
          if (open) { drawer.removeAttribute('hidden'); } else { drawer.setAttribute('hidden', ''); }
          burger.setAttribute('aria-expanded', String(open));
        });
      }
    });

    document.addEventListener('click', function (e) {
      document.querySelectorAll('details[data-mf-nav-dd][open]').forEach(function (d) {
        if (!d.contains(e.target)) d.removeAttribute('open');
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mf-b2b-catalog"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // Cajón de filtros en móvil y auto-envío, igual que en la página de colección.
    document.querySelectorAll('[data-mf-dash]').forEach(function (root) {
      var aside = root.querySelector('[data-mf-drawer]');
      var openBtn = document.querySelector('[data-mf-open]');
      var closeBtn = root.querySelector('[data-mf-close]');
      var mq = window.matchMedia('(max-width: 999px)');

      var sync = function () {
        if (!aside) return;
        if (mq.matches) { aside.setAttribute('hidden', ''); }
        else { aside.removeAttribute('hidden'); }
      };
      sync();
      mq.addEventListener('change', sync);

      if (openBtn && aside) {
        openBtn.addEventListener('click', function () {
          aside.removeAttribute('hidden');
          openBtn.setAttribute('aria-expanded', 'true');
        });
      }
      if (closeBtn && aside) {
        closeBtn.addEventListener('click', function () {
          aside.setAttribute('hidden', '');
          if (openBtn) openBtn.setAttribute('aria-expanded', 'false');
        });
      }

      root.querySelectorAll('input[type="checkbox"]').forEach(function (cb) {
        cb.addEventListener('change', function () {
          if (aside && aside.requestSubmit) aside.requestSubmit();
        });
      });
    });

    document.querySelectorAll('[data-mf-autosubmit]').forEach(function (sel) {
      sel.addEventListener('change', function () {
        var f = sel.form;
        if (f && f.requestSubmit) { f.requestSubmit(); } else if (f) { f.submit(); }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mf-featured-grid"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-mf-grid]').forEach(function (grid) {
      var tabs = grid.querySelectorAll('[data-mf-filter]');
      var cells = grid.querySelectorAll('.mf-grid__cell');
      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          var f = tab.getAttribute('data-mf-filter');
          tabs.forEach(function (t) { t.classList.toggle('is-active', t === tab); });
          cells.forEach(function (c) {
            var show = f === 'all' || c.getAttribute('data-brand') === f;
            if (show) { c.removeAttribute('hidden'); } else { c.setAttribute('hidden', ''); }
          });
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mf-main-collection"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.mf-col [data-mf-dash]').forEach(function (root) {
      var aside = root.querySelector('[data-mf-drawer]');
      var openBtn = root.parentElement.querySelector('[data-mf-open]') || document.querySelector('.mf-col [data-mf-open]');
      var closeBtn = root.querySelector('[data-mf-close]');
      if (!aside) return;
      var mq = window.matchMedia('(max-width: 999px)');
      var sync = function () {
        if (mq.matches) { aside.setAttribute('hidden', ''); } else { aside.removeAttribute('hidden'); }
      };
      sync();
      mq.addEventListener('change', sync);
      if (openBtn) openBtn.addEventListener('click', function () { aside.removeAttribute('hidden'); openBtn.setAttribute('aria-expanded', 'true'); });
      if (closeBtn) closeBtn.addEventListener('click', function () { aside.setAttribute('hidden', ''); if (openBtn) openBtn.setAttribute('aria-expanded', 'false'); });
      root.querySelectorAll('input[type="checkbox"]').forEach(function (cb) {
        cb.addEventListener('change', function () { if (aside.requestSubmit) aside.requestSubmit(); });
      });
    });
    document.querySelectorAll('.mf-col [data-mf-autosubmit]').forEach(function (sel) {
      sel.addEventListener('change', function () {
        var f = sel.form;
        if (f && f.requestSubmit) { f.requestSubmit(); } else if (f) { f.submit(); }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mf-main-product"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // --- Miniaturas: cambia la imagen principal (igual que antes, sin la lupa). ---
    function selectThumb(root, btn) {
      var main = root.querySelector('.mf-pdp__main-img');
      if (!main || !btn) return;

      var src = btn.getAttribute('data-src');
      var srcset = btn.getAttribute('data-srcset') || '';
      var alt = btn.getAttribute('data-alt');
      var index = parseInt(btn.getAttribute('data-index'), 10) || 0;
      if (!src) return;

      root.querySelectorAll('[data-mf-thumb]').forEach(function (t) {
        var on = t === btn;
        t.toggleAttribute('data-active', on);
        if (on) { t.setAttribute('aria-current', 'true'); } else { t.removeAttribute('aria-current'); }
      });

      var opener = root.querySelector('[data-mf-lightbox-open]');
      if (opener) opener.setAttribute('data-current-index', String(index));

      if (main.getAttribute('src') === src) return;

      var apply = function () {
        main.srcset = srcset;
        main.src = src;
        if (alt) main.alt = alt;
        main.classList.remove('is-loading');
      };

      var pre = new Image();
      pre.sizes = main.sizes || '';
      pre.srcset = srcset;
      pre.src = src;
      if (pre.complete) { apply(); return; }
      main.classList.add('is-loading');
      pre.addEventListener('load', apply);
      pre.addEventListener('error', apply);
    }

    // --- Lightbox: una sola instancia por producto, compartida por todo el bloque. ---
    function initLightbox(scope) {
      var lb = scope.querySelector('[data-mf-lightbox]');
      var opener = scope.querySelector('[data-mf-lightbox-open]');
      var dataEl = scope.querySelector('[data-mf-lightbox-data]');
      if (!lb || !opener || !dataEl) return;
      if (lb.hasAttribute('data-mf-lightbox-ready')) return;
      lb.setAttribute('data-mf-lightbox-ready', '');

      var images;
      try { images = JSON.parse(dataEl.textContent); } catch (e) { images = []; }
      if (!images.length) return;

      var stage = lb.querySelector('[data-mf-lightbox-stage]');
      var imgEl = lb.querySelector('[data-mf-lightbox-img]');
      var countEl = lb.querySelector('[data-mf-lightbox-count]');
      var closeBtn = lb.querySelector('[data-mf-lightbox-close]');
      var prevBtn = lb.querySelector('[data-mf-lightbox-prev]');
      var nextBtn = lb.querySelector('[data-mf-lightbox-next]');

      var index = 0;
      var lastFocused = null;

      // Estado del zoom/pan dentro del stage. scale=1 es "sin zoom".
      var scale = 1;
      var panX = 0;
      var panY = 0;
      var MIN_SCALE = 1;
      var MAX_SCALE = 4;
      var CLICK_SCALE = 2.4;

      function applyTransform() {
        imgEl.style.transform = 'translate(' + panX + 'px,' + panY + 'px) scale(' + scale + ')';
        imgEl.classList.toggle('is-zoomed', scale > 1.01);
      }

      function clampPan() {
        // Limite simple: no dejar que el pan se salga mas de lo que crece la imagen al hacer zoom.
        var rect = stage.getBoundingClientRect();
        var maxX = (rect.width * (scale - 1)) / 2;
        var maxY = (rect.height * (scale - 1)) / 2;
        panX = Math.max(-maxX, Math.min(maxX, panX));
        panY = Math.max(-maxY, Math.min(maxY, panY));
      }

      function resetZoom() {
        scale = 1; panX = 0; panY = 0;
        applyTransform();
      }

      function render() {
        var item = images[index];
        if (!item) return;
        resetZoom();
        imgEl.src = item.zoomSrc || item.src;
        imgEl.alt = item.alt || '';
        if (countEl) countEl.textContent = String(index + 1);
        if (prevBtn) prevBtn.disabled = images.length < 2;
        if (nextBtn) nextBtn.disabled = images.length < 2;
      }

      function open(atIndex) {
        index = Math.max(0, Math.min(images.length - 1, atIndex || 0));
        lastFocused = document.activeElement;
        render();
        lb.hidden = false;
        document.documentElement.style.overflow = 'hidden';
        closeBtn.focus();
      }

      function close() {
        lb.hidden = true;
        document.documentElement.style.overflow = '';
        if (lastFocused && lastFocused.focus) lastFocused.focus();
      }

      function go(delta) {
        if (images.length < 2) return;
        index = (index + delta + images.length) % images.length;
        render();
      }

      opener.addEventListener('click', function () {
        open(parseInt(opener.getAttribute('data-current-index'), 10) || 0);
      });
      opener.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          open(parseInt(opener.getAttribute('data-current-index'), 10) || 0);
        }
      });

      closeBtn.addEventListener('click', close);
      if (prevBtn) prevBtn.addEventListener('click', function () { go(-1); });
      if (nextBtn) nextBtn.addEventListener('click', function () { go(1); });

      lb.addEventListener('click', function (e) {
        if (e.target === lb) close();
      });

      document.addEventListener('keydown', function (e) {
        if (lb.hidden) return;
        if (e.key === 'Escape') close();
        else if (e.key === 'ArrowLeft') go(-1);
        else if (e.key === 'ArrowRight') go(1);
      });

      // --- Clic (mouse) para acercar/alejar, centrado en el punto donde se hizo clic. ---
      imgEl.addEventListener('click', function (e) {
        if (e.pointerType === 'touch') return; // el touch se maneja abajo, aparte
        if (scale > 1.01) {
          resetZoom();
          return;
        }
        var rect = imgEl.getBoundingClientRect();
        var offsetX = e.clientX - (rect.left + rect.width / 2);
        var offsetY = e.clientY - (rect.top + rect.height / 2);
        scale = CLICK_SCALE;
        panX = -offsetX * (scale - 1) / scale;
        panY = -offsetY * (scale - 1) / scale;
        clampPan();
        applyTransform();
      });

      // --- Touch: pellizco para zoom, un dedo para arrastrar (si hay zoom) o deslizar
      //     entre fotos (si no hay zoom). Todo con Pointer Events para no depender de
      //     gestos nativos del navegador, que no dan control fino sobre el pan. ---
      var pointers = new Map();
      var pinchStartDist = 0;
      var pinchStartScale = 1;
      var dragStart = null; // { x, y, panX, panY }
      var swipeStartX = null;

      function dist(a, b) {
        return Math.hypot(a.x - b.x, a.y - b.y);
      }

      stage.addEventListener('pointerdown', function (e) {
        pointers.set(e.pointerId, { x: e.clientX, y: e.clientY });
        if (pointers.size === 1) {
          if (scale > 1.01) {
            dragStart = { x: e.clientX, y: e.clientY, panX: panX, panY: panY };
          } else if (e.pointerType === 'touch') {
            swipeStartX = e.clientX;
          }
        } else if (pointers.size === 2) {
          dragStart = null;
          swipeStartX = null;
          var pts = Array.from(pointers.values());
          pinchStartDist = dist(pts[0], pts[1]) || 1;
          pinchStartScale = scale;
        }
      });

      stage.addEventListener('pointermove', function (e) {
        if (!pointers.has(e.pointerId)) return;
        pointers.set(e.pointerId, { x: e.clientX, y: e.clientY });

        if (pointers.size === 2) {
          var pts = Array.from(pointers.values());
          var d = dist(pts[0], pts[1]);
          if (d && pinchStartDist) {
            scale = Math.max(MIN_SCALE, Math.min(MAX_SCALE, pinchStartScale * (d / pinchStartDist)));
            clampPan();
            applyTransform();
          }
        } else if (pointers.size === 1 && dragStart) {
          panX = dragStart.panX + (e.clientX - dragStart.x);
          panY = dragStart.panY + (e.clientY - dragStart.y);
          clampPan();
          applyTransform();
        }
      });

      function endPointer(e) {
        // Deslizar (solo un dedo, sin zoom activo) para pasar de foto.
        if (pointers.size === 1 && swipeStartX !== null && scale <= 1.01) {
          var delta = e.clientX - swipeStartX;
          if (Math.abs(delta) > 48) go(delta > 0 ? -1 : 1);
        }
        pointers.delete(e.pointerId);
        if (pointers.size < 2) { pinchStartDist = 0; }
        if (pointers.size === 0) {
          dragStart = null;
          swipeStartX = null;
          if (scale < 1.02) resetZoom(); // por si quedo un residuo minimo
        }
      }
      stage.addEventListener('pointerup', endPointer);
      stage.addEventListener('pointercancel', endPointer);

      // Doble tap tactil = acercar/alejar centrado, equivalente movil del clic de escritorio.
      var lastTap = 0;
      stage.addEventListener('pointerup', function (e) {
        if (e.pointerType !== 'touch') return;
        var now = Date.now();
        if (now - lastTap < 300 && pointers.size === 0) {
          if (scale > 1.01) {
            resetZoom();
          } else {
            var rect = imgEl.getBoundingClientRect();
            var offsetX = e.clientX - (rect.left + rect.width / 2);
            var offsetY = e.clientY - (rect.top + rect.height / 2);
            scale = CLICK_SCALE;
            panX = -offsetX * (scale - 1) / scale;
            panY = -offsetY * (scale - 1) / scale;
            clampPan();
            applyTransform();
          }
        }
        lastTap = now;
      });
    }

    function init(root) {
      if (root.hasAttribute('data-mf-pdp-ready')) return;
      root.setAttribute('data-mf-pdp-ready', '');
      root.querySelectorAll('[data-mf-thumb]').forEach(function (t) {
        t.addEventListener('click', function () { selectThumb(root, t); });
      });
    }

    function initAll(scope) {
      (scope || document).querySelectorAll('[data-mf-pdp]').forEach(init);
      (scope || document).querySelectorAll('.mf-sec.mf-pdp').forEach(function (sec) {
        initLightbox(sec.parentElement || document);
      });
    }

    initAll();
    document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mf-product-rail"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-mf-rail]').forEach(function (rail) {
      var track = rail.querySelector('[data-mf-track]');
      if (!track) return;
      var step = function () { return Math.min(track.clientWidth * 0.8, 640); };
      var prev = rail.querySelector('[data-mf-prev]');
      var next = rail.querySelector('[data-mf-next]');
      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mf-related-products"]) return;
  try {
    
  (function () {
    function bindRail(rail) {
      if (rail.hasAttribute('data-mf-rail-ready')) return;
      rail.setAttribute('data-mf-rail-ready', '');
      var track = rail.querySelector('[data-mf-track]');
      if (!track) return;
      var step = function () { return Math.min(track.clientWidth * 0.8, 640); };
      var prev = rail.querySelector('[data-mf-prev]');
      var next = rail.querySelector('[data-mf-next]');
      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
    }

    function initRelated(root) {
      var url = root.getAttribute('data-url');
      if (!url) return;
      fetch(url)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var tmp = document.createElement('div');
          tmp.innerHTML = html;
          var fresh = tmp.querySelector('[data-mf-related]');
          if (fresh && fresh.innerHTML.trim() !== '') {
            root.innerHTML = fresh.innerHTML;
            root.querySelectorAll('[data-mf-rail]').forEach(bindRail);
          }
        })
        .catch(function () {});
    }

    // El fallback ya viene pintado en la carga inicial (server-side), asi que
    // solo se re-consulta por fetch cuando esta section arranca vacia del todo
    // (ni recomendaciones ni fallback): asi no se pisa un fallback ya bueno con
    // un intento async que muy probablemente tambien vuelva vacio.
    document.querySelectorAll('[data-mf-related]').forEach(function (root) {
      if (root.innerHTML.trim() === '') {
        initRelated(root);
      } else {
        root.querySelectorAll('[data-mf-rail]').forEach(bindRail);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mf-testimonial-feature"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-mf-test]').forEach(function (root) {
      var slides = root.querySelectorAll('[data-mf-slide]');
      var dots = root.querySelectorAll('[data-mf-dot]');
      if (slides.length < 2) return;
      var i = 0;
      var go = function (n) {
        i = (n + slides.length) % slides.length;
        slides.forEach(function (s, k) { s.classList.toggle('is-active', k === i); });
        dots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); });
      };
      var prev = root.querySelector('[data-mf-prev]');
      var next = root.querySelector('[data-mf-next]');
      if (prev) prev.addEventListener('click', function () { go(i - 1); });
      if (next) next.addEventListener('click', function () { go(i + 1); });
      dots.forEach(function (d) { d.addEventListener('click', function () { go(parseInt(d.getAttribute('data-mf-dot'), 10)); }); });
      var ap = root.getAttribute('data-autoplay');
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (ap && !reduce) { setInterval(function () { go(i + 1); }, parseInt(ap, 10) * 1000); }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mf-warranty-forms"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-mf-warranty]').forEach(function (root) {
      var tabsEl = root.querySelector('[data-mf-warranty-tabs]');
      var tabs = Array.prototype.slice.call(root.querySelectorAll('[role="tab"]'));
      var panels = Array.prototype.slice.call(root.querySelectorAll('[data-mf-warranty-panel]'));
      if (!tabsEl || tabs.length !== panels.length || !tabs.length) return;

      var storeKey = 'mf-warranty-tab';

      function activate(index, focusTab) {
        tabs.forEach(function (tab, i) {
          var on = i === index;
          tab.classList.toggle('is-active', on);
          tab.setAttribute('aria-selected', String(on));
          tab.tabIndex = on ? 0 : -1;
          panels[i].hidden = !on;
        });
        if (focusTab) tabs[index].focus();
      }

      tabs.forEach(function (tab, i) {
        tab.addEventListener('click', function () {
          activate(i);
        });
        tab.addEventListener('keydown', function (e) {
          var delta = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0;
          if (!delta) return;
          e.preventDefault();
          activate((i + delta + tabs.length) % tabs.length, true);
        });
      });

      // Al enviar, recordamos la pestaña para restaurarla tras el redirect de
      // Shopify; si no, un envío desde la segunda caería siempre en la primera.
      panels.forEach(function (panel, i) {
        var form = panel.querySelector('form');
        if (!form) return;
        form.addEventListener('submit', function () {
          try { sessionStorage.setItem(storeKey, String(i)); } catch (err) {}
        });
      });

      var restored = 0;
      try {
        var saved = sessionStorage.getItem(storeKey);
        if (saved !== null) {
          restored = parseInt(saved, 10) || 0;
          sessionStorage.removeItem(storeKey);
        }
      } catch (err) {}

      tabsEl.hidden = false;
      activate(Math.min(restored, tabs.length - 1));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search"]) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-mf-dash]').forEach(function (root) {
      var aside = root.querySelector('[data-mf-drawer]');
      var openBtn = document.querySelector('[data-mf-open]');
      var closeBtn = root.querySelector('[data-mf-close]');
      var mq = window.matchMedia('(max-width: 999px)');

      var sync = function () {
        if (!aside) return;
        if (mq.matches) { aside.setAttribute('hidden', ''); }
        else { aside.removeAttribute('hidden'); }
      };
      sync();
      mq.addEventListener('change', sync);

      if (openBtn && aside) {
        openBtn.addEventListener('click', function () {
          aside.removeAttribute('hidden');
          openBtn.setAttribute('aria-expanded', 'true');
        });
      }
      if (closeBtn && aside) {
        closeBtn.addEventListener('click', function () {
          aside.setAttribute('hidden', '');
          if (openBtn) openBtn.setAttribute('aria-expanded', 'false');
        });
      }

      root.querySelectorAll('input[type="checkbox"]').forEach(function (cb) {
        cb.addEventListener('change', function () {
          if (aside && aside.requestSubmit) aside.requestSubmit();
        });
      });
    });

    document.querySelectorAll('[data-mf-autosubmit]').forEach(function (sel) {
      sel.addEventListener('change', function () {
        var f = sel.form;
        if (f && f.requestSubmit) { f.requestSubmit(); } else if (f) { f.submit(); }
      });
    });

  })();

  } catch(e) { console.error(e); }
})();
})();
